<template>
<div>
    <VueCtkDateTimePicker v-model="formData[item.fieldName]" :no-label="true" :range="true" />
</div>

</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
    props: ['item', 'formData'],
    components: {
        VueCtkDateTimePicker
    }
}
</script>